import { render, staticRenderFns } from "./industryActivityCatalogue.vue?vue&type=template&id=023b822c&scoped=true"
import script from "./industryActivityCatalogue.vue?vue&type=script&lang=js"
export * from "./industryActivityCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b822c",
  null
  
)

export default component.exports